export const INITIAL_DATA = {
  isProfileComplete: {
    isAuthenticated: false,
    isCompleted: false,
    isPhoneNumberConfirmed: false,
    unviewedCount: 0,
  },
};
